import React from 'react'
import Css from '../assets/skills/css.png'
import Github from '../assets/skills/github.png'
import Html from '../assets/skills/html.png'
import JS from '../assets/skills/javascript.png'
import TailWind from '../assets/skills/tailwind.png'
import RReact from '../assets/skills/react.png'
const Skills = () => {
  return (
    <div id = 'skills' className = "w-full lg:h-screen">
        <div className = "max-w-[1240px] flex flex-col mx-auto justify-center h-full">
            <div className = "flex justify-center items-center flex-col">
            <p className = "text-4xl tracking-widest text-[#5651e5]">SKILLS</p>
            <h2 className = "py-4 text-xl">What I Can Do</h2>
            </div>
            
            <div className = "grid md:grid-cols-2 lg:grid-cols-3 gap-8">

                <div className = "p-6 shadow-xl rounded-xl hover:scale-105 ease-in duration-300 ">
                    <div className = "grid grid-cols-2 gap-4 justify-center items-center">
                        <div className = "m-auto">
                            <img src={Html} alt="" width = "70px" height = "70px" />
                        </div>
                        <div className = "flex flex-col items-center justify-center ">
                            <h3>HTML</h3>
                        </div>
                    </div>
                </div>

                <div className = "p-6 shadow-xl rounded-xl hover:scale-105 ease-in duration-300">
                    <div className = "grid grid-cols-2 gap-3 justify-center items-center">
                        <div className = "m-auto">
                            <img src={Css} alt=""  width = "70px" height = "70px" />
                        </div>
                        <div className = "flex flex-col items-center justify-center">
                            <h3>CSS</h3>
                        </div>
                    </div>
                </div>

                <div className = "p-6 shadow-xl rounded-xl hover:scale-105 ease-in duration-300">
                    <div className = "grid grid-cols-2 gap-3 justify-center items-center">
                        <div className = "m-auto">
                            <img src={JS} alt=""  width = "70px" height = "70px" />
                        </div>
                        <div className = "flex flex-col items-center justify-center">
                            <h3>JavaScript</h3>
                        </div>
                    </div>
                </div>

                <div className = "p-6 shadow-xl rounded-xl hover:scale-105 ease-in duration-300">
                    <div className = "grid grid-cols-2 gap-3 justify-center items-center">
                        <div className = "m-auto">
                            <img src={RReact} alt=""  width = "70px" height = "70px" />
                        </div>
                        <div className = "flex flex-col items-center justify-center">
                            <h3>React</h3>
                        </div>
                    </div>
                </div>

                <div className = "p-6 shadow-xl rounded-xl hover:scale-105 ease-in duration-300">
                    <div className = "grid grid-cols-2 gap-3 justify-center items-center">
                        <div className = "m-auto">
                            <img src={TailWind} alt=""  width = "70px" height = "70px" />
                        </div>
                        <div className = "flex flex-col items-center justify-center">
                            <h3>TailWind</h3>
                        </div>
                    </div>
                </div>

                <div className = "p-6 shadow-xl rounded-xl hover:scale-105 ease-in duration-300">
                    <div className = "grid grid-cols-2 gap-3 justify-center items-center">
                        <div className = "m-auto">
                            <img src={Github} alt=""  width = "70px" height = "70px" />
                        </div>
                        <div className = "flex flex-col items-center justify-center">
                            <h3>Github</h3>
                        </div>
                    </div>
                </div>

            </div>
        </div>
      
    </div>
  )
}

export default Skills
